/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eg_Monfri_9am5pmInputs */

const en_eg_monfri_9am5pm = /** @type {(inputs: Eg_Monfri_9am5pmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Mon-Fri 9am-5pm`)
};

const es_eg_monfri_9am5pm = /** @type {(inputs: Eg_Monfri_9am5pmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Lun-Vie 9am-5pm`)
};

const fr_eg_monfri_9am5pm = /** @type {(inputs: Eg_Monfri_9am5pmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Lun-Ven 9h-17h`)
};

const de_eg_monfri_9am5pm = /** @type {(inputs: Eg_Monfri_9am5pmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Mo-Fr 9-17 Uhr`)
};

const ja_eg_monfri_9am5pm = /** @type {(inputs: Eg_Monfri_9am5pmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: 月〜金 午前9時〜午後5時`)
};

const zh_eg_monfri_9am5pm = /** @type {(inputs: Eg_Monfri_9am5pmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：周一至周五 9am-5pm`)
};

const ar_eg_monfri_9am5pm = /** @type {(inputs: Eg_Monfri_9am5pmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مثال: الإثنين-الجمعة 9 ص-5 م`)
};

const id_eg_monfri_9am5pm = /** @type {(inputs: Eg_Monfri_9am5pmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. Sen-Jum 09:00-17:00`)
};

const it_eg_monfri_9am5pm = /** @type {(inputs: Eg_Monfri_9am5pmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Lun-Ven 9:00-17:00`)
};

const ru_eg_monfri_9am5pm = /** @type {(inputs: Eg_Monfri_9am5pmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, Пн-Пт 9:00-17:00`)
};

const pt_eg_monfri_9am5pm = /** @type {(inputs: Eg_Monfri_9am5pmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Seg-Sex 9h-17h`)
};

const ko_eg_monfri_9am5pm = /** @type {(inputs: Eg_Monfri_9am5pmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예: 월~금 오전 9시~오후 5시`)
};

/**
* | output |
* | --- |
* | "e.g. Mon-Fri 9am-5pm" |
*
* @param {Eg_Monfri_9am5pmInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const eg_monfri_9am5pm = /** @type {((inputs?: Eg_Monfri_9am5pmInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eg_Monfri_9am5pmInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eg_monfri_9am5pm(inputs)
	if (locale === "es") return es_eg_monfri_9am5pm(inputs)
	if (locale === "fr") return fr_eg_monfri_9am5pm(inputs)
	if (locale === "de") return de_eg_monfri_9am5pm(inputs)
	if (locale === "ja") return ja_eg_monfri_9am5pm(inputs)
	if (locale === "zh") return zh_eg_monfri_9am5pm(inputs)
	if (locale === "ar") return ar_eg_monfri_9am5pm(inputs)
	if (locale === "id") return id_eg_monfri_9am5pm(inputs)
	if (locale === "it") return it_eg_monfri_9am5pm(inputs)
	if (locale === "ru") return ru_eg_monfri_9am5pm(inputs)
	if (locale === "pt") return pt_eg_monfri_9am5pm(inputs)
	return ko_eg_monfri_9am5pm(inputs)
});